// extracted by mini-css-extract-plugin
export default {"wordsForm":"WordForm_wordsForm__YM5Mn","wordsFormWrapper":"WordForm_wordsFormWrapper__N3njC"};